import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useDemo } from "@/context/DemoContext";

export function DemoTransition() {
  const { launching } = useDemo();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!launching) {
      setProgress(0);
      return;
    }
    let start;
    let raf;
    const tick = (t) => {
      if (!start) start = t;
      const p = Math.min(100, ((t - start) / 2000) * 100);
      setProgress(p);
      if (p < 100) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [launching]);

  return (
    <AnimatePresence>
      {launching && (
        <motion.div
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#040405]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          data-testid="demo-transition-overlay"
        >
          {/* particle burst */}
          <div className="pointer-events-none absolute inset-0 overflow-hidden">
            {Array.from({ length: 40 }).map((_, i) => (
              <motion.span
                key={i}
                className="absolute h-1 w-1 rounded-full"
                style={{
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                  background: "var(--accent)",
                }}
                initial={{ opacity: 0, scale: 0 }}
                animate={{
                  opacity: [0, 1, 0],
                  scale: [0, 1.4, 0],
                  y: [0, -30],
                }}
                transition={{
                  duration: 1.6,
                  repeat: Infinity,
                  delay: Math.random() * 1.5,
                }}
              />
            ))}
          </div>

          <motion.div
            className="relative z-10 flex flex-col items-center px-6 text-center"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            <p className="font-mono text-xs tracking-[0.4em] text-white/50">
              COGENTIS TECHNOLOGIES
            </p>
            <h2 className="font-display mt-4 text-3xl font-light tracking-tight text-white sm:text-4xl">
              Engineering Certainty.
            </h2>
            <p className="font-mono mt-6 text-sm tracking-[0.2em] text-white/60">
              INITIALIZING CRASH READY
              <span className="animate-pulse">…</span>
            </p>

            <div className="mt-8 h-[3px] w-64 overflow-hidden rounded-full bg-white/10 sm:w-80">
              <div
                className="h-full rounded-full transition-[width] duration-75 ease-linear"
                style={{
                  width: `${progress}%`,
                  background: "var(--accent)",
                  boxShadow: "0 0 16px var(--accent-glow)",
                }}
              />
            </div>
            <p className="font-mono mt-3 text-[11px] tracking-[0.2em] text-white/30">
              {Math.round(progress)}%
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
